<template>
  <div class="card card-with-search border-0 card-with-shadow">
    <div class="text-justify">
      <div class="row">
        <!-- <dynamic-form-preview v-bind:Id="id"></dynamic-form-preview> -->
        <div class="col-12">
          <!-- pdf-orientation="landscape" -->
          <div id="pdf-section" class="container-wrapper" ref="pdfSection" >
            <div class="stacked-divs" id="print">
              <!-- Header -->
              <div class="position-relative form-header p-3">
                <table class="my-3 align-items-center container_btn" v-if="companyInfo != null" style="width: 100%; border-collapse: collapse;">
                  <tr>
                    <td class="border-right" style="width: 60%;">
                      <table class="user-header-media" style="width: 100%;  font-size: 0.8rem;">
                        <tr>
                          <td style="width: 30%; padding-right: 1rem;">
                            <img v-if="companyInfoCheck.checked_logo == true" :src="companyInfo.logo" alt="LOGO" style="width: 100%; height: auto;" />
                          </td>
                          <td>
                            <h6 class="mb-0">{{ companyInfoCheck.checked_company_name == true ? companyInfo.company_name : ''}} <span v-if="companyInfoCheck.checked_category_name == true">{{ ' (' + companyInfo.category_name + ')' }}</span></h6>
                            <p class="mt-2" v-if="companyInfoCheck.checked_company_number == true">Reg No. {{ companyInfo.comapny_number }}</p>
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td style="width: 40%; ">
                      <table style="width: 100%;  font-size: 0.8rem;">
                        <tr v-if="companyInfoCheck.checked_company_phone == true">
                          <td style="padding-right: 1rem;">
                            <app-icon :name="'phone'" class="icon-size"/>
                          </td>
                          <td>
                            <p class="mb-1">{{ companyInfo.company_phone }}</p>
                          </td>
                        </tr>
                        <tr v-if="companyInfoCheck.checked_company_email == true">
                          <td style="padding-right: 1rem;">
                            <app-icon :name="'mail'" class="icon-size"/>
                          </td>
                          <td>
                            <p class="mb-1">{{ companyInfo.company_email }}</p>
                          </td>
                        </tr>
                        <tr v-if="companyInfoCheck.checked_address == true">
                          <td style="padding-right: 1rem;">
                            <app-icon :name="'map-pin'" class="icon-size"/>
                          </td>
                          <td>
                            <p class="mb-1">{{ companyInfo.address }}</p>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
                <div class="col-12 text-center">
                  <p class="mb-2" v-if="companyInfoCheck.checked_description == true">
                    {{ companyInfo.description }}
                  </p>
                </div>
              </div>
              <!-- Header Ends-->

              <div class="main__wrapper header-color-style formStyle form-inner-container p-3">

                <el-container>
                  <el-main :style="cssProps" >
                    <el-form class="formElements">
                      <template v-for="(eachFormObj, eachFormIndex) in forms">
                        <!--                        <div v-if="eachFormIndex > 0" class="html2pdf__page-break"/>-->

                        <el-col :span="24" v-if="showSectionSwitch">
                          <el-checkbox  v-model="eachFormObj.showSection">Check if applicable</el-checkbox>
                        </el-col>
                        <el-divider :key="`divider-${eachFormIndex}`" content-position="center">{{ eachFormObj.title }}</el-divider>
                        <el-row :key="`row-${eachFormIndex}`" v-show="getSectionView(eachFormIndex)">
                          <div class="wrapper--forms">
                            <!--                            <el-col :xs="24" :sm="24"-->
                            <el-col
                                v-for="(field, index) in eachFormObj.fields"
                                :key="index"
                                :span="field.span"
                                v-bind="field"
                                class="form__group, position-relative pdf-item"
                                :class="{'is---active':componentFieldId === field.componentId,}"
                            >

                              <div @click="editElementProperties(field)">
                                <component :class="{'is---active':componentFieldId === field.componentId,}"
                                           :is="field.fieldType"
                                           :currentField="field"
                                           class="form__field"
                                ></component>

                              </div>

                              <div class="form__actiongroup text-right"
                                   v-if="showStyleDiv == false && field.showComments"
                                   :style="hideOnPrint == true ? 'display:none' : 'display:block'">
                                <el-button-group
                                    class="form__actionlist hide_button"
                                    :class="{show_party:componentFieldId === field.componentId,}">
                                  <!--                                comment Icon    icon="el-icon-plus"-->
                                  <el-button size="mini" icon="el-icon-plus"
                                             @click="(event)=>cloneElementField(index,field,eachFormObj.fields, event)"
                                             v-show="!field.isUnique"
                                  ></el-button>
                                  <div class="comment-section" :id="'comment-container-'+field.componentId"
                                       ref="commentRefClick">
                                    <div class="message-input d-flex p-2 align-items-center">
                                      <input
                                          type="text"
                                          :v-bind-value="textComment[field.componentId]"
                                          class="form-control"
                                          placeholder="Type Comment"
                                          v-model="textComment[field.componentId]"
                                          v-on:keydown.enter.prevent="enter(textComment, field.componentId)"
                                      />
                                      <div class="message-input-append">
                                        <a
                                            href="#"
                                            class="btn btn-send p-2"
                                            @click.prevent="enter(textComment, field.componentId)"
                                        >
                                          <app-icon name="send" class="size-25"/>
                                        </a>

                                      </div>
                                    </div>
                                    <div class="card-body pb-0">
                                      <div class="row">
                                        <div class="col-sm-12">
                                          <div class="my-3 aqeel-class"
                                               v-for="(comm, commentIndex) in commentObject[field.componentId]"
                                               :key="commentIndex">
                                            <div class="d-flex" style="justify-content: space-between">
                                                    <span class="meta">
                                                      <app-media-object :media-title="comm.user"/>
                                                      <p>{{ comm.created_at | formatDate }}</p>
                                                    </span>

                                              <el-dropdown trigger="click">

                                                <el-button type="primary" class="btn btn-sm"
                                                           style="background: white;color: #4466f2;border: none;">
                                                  <app-icon name="more-vertical"
                                                            style="width: 10px !important;height: 10px !important;"/>
                                                </el-button>
                                                <el-dropdown-menu slot="dropdown">

                                                </el-dropdown-menu>
                                              </el-dropdown>
                                            </div>
                                            <p style="margin: 6px 0;border-bottom: 1px solid rgb(137 137 137 / 53%);">{{ comm.text }}</p>
                                          </div>
                                        </div>
                                      </div>

                                    </div>


                                  </div>
                                </el-button-group>
                              </div>

                            </el-col>

                          </div>
                        </el-row>

                      </template>
                    </el-form>
                  </el-main>
                </el-container>
                <div class="form-footer">
                  <div class="row btn-border m-3 align-items-center" />
                  <div style="display: flex; justify-content:space-between" class="ml-4 mr-4">
                    <p>
                      <small>Form ID: {{companyInfo.company_name && companyInfo.company_name.match(/\b(\w)/g).join('')+'C'+formInfo.id}}</small>
                    </p>
                    <p>
                      <small>Version: {{formInfo.version}}</small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="styling-block" v-if="showStyleDiv == true">
              <!-- For Form Styling Div -->

              <div class="col-12 collapse-title-size">
                <el-collapse v-model="activeName" accordion class="mt-3 border-top-none">
                  <!-- Header Setting -->
                  <el-collapse-item title="Header Setting" name="1">
                    <div class="row mb-2 p-2">
                      <div class="col-12 mb-2">
                        <h5>Select header content</h5>
                      </div>

                      <div class="col-6 mb-2">
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('logo')"
                              v-model="companyInfoCheck.checked_logo"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('company_name')"
                              v-model="companyInfoCheck.checked_company_name"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('company_number')"
                              v-model="companyInfoCheck.checked_company_number"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('category_name')"
                              v-model="companyInfoCheck.checked_category_name"
                          />
                        </div>
                      </div>
                      <div class="col-6 mb-2">
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('company_email')"
                              v-model="companyInfoCheck.checked_company_email"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('company_phone')"
                              v-model="companyInfoCheck.checked_company_phone"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('address')"
                              v-model="companyInfoCheck.checked_address"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('description')"
                              v-model="companyInfoCheck.checked_description"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2 p-2">
                      <div class="col-12 mb-2">
                        <div class="row p-2">
                          <div class="col-6 p-2">
                            <label for="inputs_form_header_color" class="mb-0">{{ $t("Header background color") }}</label>
                            <input id="inputs_form_header_color" class="form-control" type="color" v-model="form_header_color"/>
                          </div>

                          <div class="col-6 p-2">
                            <label for="form_header_text_color" class="mb-0">{{ $t("Header text color") }}</label>
                            <input id="form_header_text_color" class="form-control" type="color" v-model="form_header_text_color"/>
                          </div>
                        </div>


                      </div>
                    </div>
                  </el-collapse-item>
                  <!-- Header Setting -->

                  <!-- Form Styling -->
                  <el-collapse-item title="Form Designer" name="2">
                    <div class="row mb-2 p-2">
                      <div class="col-12">
                        <h5>Select your Theme</h5>
                      </div>
                    </div>
                    <div class="row mb-3 p-2">
                      <div class="col-3">
                        <div class="box-01">
                          <p class="box-text-color" @click.prevent="changeColor(1)">A</p>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="box-02">
                          <p class="box-text-color" @click.prevent="changeColor(2)">A</p>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="box-03">
                          <p class="box-text-color" @click.prevent="changeColor(3)">A</p>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="box-04">
                          <p class="box-text-color" @click.prevent="changeColor(4)">A</p>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-5 p-2">
                      <div class="col-6">
                        <label for="inputs_form_color" class="mb-0">{{ $t("form_color") }}</label>
                        <input id="inputs_form_color" class="form-control" type="color" v-model="form_color"/>
                      </div>
                      <!-- <div class="col-6">
                        <label for="inputs_form_border_color" class="mb-0">{{ $t("form_border_color") }}</label>
                        <input
                            id="inputs_form__border_color"
                            class="form-control"
                            type="color"
                            v-model="form_border_color"
                        />
                      </div> -->
                    </div>
                    <div class="row mb-5 p-2">
                      <div class="col-6 mt-2">
                        <label for="inputs_font_color" class="mb-0">{{ $t("font_color") }}</label>
                        <input id="inputs_font_color" class="form-control" type="color" v-model="font_color"/>
                      </div>
                      <!-- <div class="col-6 mt-5">
                        <label for="inputs_input_back_color" class="mb-0">
                          {{ $t("input_back_color") }}
                        </label>
                        <input id="inputs_input_back_color"
                          class="form-control"
                          type="color"
                          v-model="inputs.input_back_color">
                      </div>-->
                    </div>
                  </el-collapse-item>
                  <!-- Form Styling -->
                </el-collapse>
                <div class="row">
                  <div class="col-12 mt-5" style="display:flex; justify-content:space-between">
                    <button
                        type="button"
                        class="btn btn-primary"
                        data-dismiss="modal"
                        @click.prevent="previous"
                    >{{ $t("Previous") }}
                    </button>
                    <!-- </div>
                    <div class="col-6 mt-5">-->
                    <button
                        type="button"
                        class="btn btn-success"
                        @click.prevent="saveStyling"
                    >{{ $t("Save Styling") }}
                    </button>
                  </div>
                </div>
              </div>

              <!-- For Form Styling Div -->
            </div>
          </div>


          <div class="ml-5 d-flex justify-content-center form-footer-buttons">
            <button v-if="view_type != null" @click.prevent="generateReport" class="btn btn-primary m-1">Print</button>

            <app-input class="m-1"
                       type="radio-buttons"
                       :list="updateStrategyList"
                       hidden
                       v-model="isUpdateStrategy"/>

            <app-load-more
                :preloader="actionPreloader"
                :label="$t('save_&_submit')"
                type="submit"
                class-name="btn-success m-1"
                @submit="saveForm('submitted', true)"
            />
            <button @click.prevent="backToList" class="btn btn-success m-1">Back</button>

          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {ModalMixin} from "../../../../Mixins/ModalMixin";
import {FormMixin} from "../../../../../core/mixins/form/FormMixin";
import {FormBuilder} from "../../CustomFormBuilder/form_elements/formbuilder";
import {axiosGet, axiosPost} from "../../../../../app/Helpers/AxiosHelper";

import {
  BODY_STYLE_UPDATE,
  COMPANY_INVOICE_SATUS,
  FORM_INPUT_COMMENT_DELETE,
  FORM_INPUT_COMMENT_LIST,
  FORM_INPUT_COMMENT_STORE,
  FORM_INPUT_COMMENT_UPDATE,
  GUEST_FORM,
  GUEST_FORM_SUBMIT,
  TASK_AUDIT
} from "../../../../Config/ApiUrl";
import {
  cloneElementField,
  deleteComment,
  editComment,
  editElementProperties,
  enter,
  focusInput,
  generateReport, getAllDocumentStyles,
  getInputsComments,
  getQueryParam,
  getSectionView, getStyles,
  invoiceStatus,
  reloadFun,
  saveForm,
  setFormColor,
  taskAudit, waitForStylesheets
} from "@Views/CustomFormBuilder/utilities/formPreview";

export default {
  name: "FormBuilderModal",

  components: FormBuilder.$options.components,
  mixins: [ModalMixin, FormMixin],
  props: {
    id: Number,
    taskId: Number,
    form_id: Number,
    formBodyId: Number,
    form_revision_id: Number,
    type: String,
    showStyleDiv: Boolean,
    backList: Function,
    userId: Number,
    response: String,
    back: Function,
    guestUuid:String,

  },
  data() {
    return {

      isNewTab: 'no',
      actionPreloader: false,
      showSectionSwitch: true,
      updateStrategyList: [
        {
          id: 'update',
          value: 'Update Existing'
        },{
          id: 'create',
          value: 'Create New'
        },],
      isUpdateStrategy: 'update',
      // flag: null,
      // formDesign: this.$store.state.formdesigner.formstyling,
      activeName: 1,
      companyInfoCheck: {
        checked_company_name: false,
        checked_logo: false,
        checked_company_number: false,
        checked_company_email: false,
        checked_company_phone: false,
        checked_address: false,
        checked_description: false,
        checked_category_name: false,
      },
      formStatus: 0,
      hideOnPrint: false,
      formInfo: {},
      on_select: false,
      form_color: "",
      form_header_color: "",
      form_header_text_color: "",
      font_color: "",
      select_color: [{
        form_header_color: this.form_header_color,
        form_header_text_color: this.form_header_text_color,
        form_color: this.form_color,
        font_color: this.font_color,
      }],
      form_border_color: "",
      root: null,
      // accentColor: '#000',
      view_type: "",
      companyInfo: {},
      user_id: "",
      invoice_Status: "",
      remove_id: "",
      deleteConfirmationModalActive: false,
      uploadFilePathfinal: {},
      fieldId: [],
      textCommentId: 0,
      commentRequest: {},
      textComment: {},
      created_by: 0,
      task_id: "",
      form_body_id: 0,
      forms: this.$store.state.formBuilder.forms,
      commentObject: {},
      commentText: "",
      componentFieldId: 0,
      themingVars: this.$store.state.formBuilder.themingVars,
      preloader: false,
      inputs: {
        yes: "no"
      },
      // status:'',
      modalId: "form-view-Modal",
      modalTitle: this.$t("add"),
      color_data: [
        {
          theme_no: 1,
          form_color: "#F0FCFF",
          form_border_color: "#83D0E4",
          font_color: "#264B67"
        },
        {
          theme_no: 2,
          form_color: "#FFDF79",
          form_border_color: "#FB6F41",
          font_color: "#6A1B00"
        },
        {
          theme_no: 3,
          form_color: "#EFE8D4",
          form_border_color: "#5A4B44",
          font_color: "#321F16"
        },
        {
          theme_no: 4,
          form_color: "#E4EFFF",
          form_border_color: "#2462B9",
          font_color: "#12458D"
        }
      ]
    };
  },
  methods: {
    backToList() {

     this.$emit('back')
    },
    generateReport,
    getSectionView,
    previous() {
      this.$emit("id", 1);
    },
    canceled() {
      this.remove_id = "";
      this.deleteConfirmationModalActive = false;
    },
    confirmed() {
      this.$store.state.uploadFilePath.dataUploadFilePath.splice(
          this.remove_id,
          1
      );

      this.hideDeleteModal();
    },
    hideDeleteModal() {
      this.deleteLoader = false;
      $("#task-delete").modal("hide");
      this.canceled();
    },
    async getData() {
      // let form_id = this.getQueryParam();
      /**
       * * Pass the value to server, so that we can get required form response,
       * */
      let url = GUEST_FORM;
      let body = {
        form_id : this.form_id,
        form_body_id : this.formBodyId,
        user : this.$store.state.sharedData.sharedData.guestUserData,
        taskId: this.$store.state.sharedData.sharedData.guestTaskAttrs.taskdata.task_id,
      }
      this.$store.commit('updateSharedData', {index: "formPreviewUrl", newValue: url})
      axiosPost(url, body)
          .then(res => {

            if (res.data.length !== 0) {
              this.forms = res.data.body;
              this.form_body_id = res.data.id;
              this.form_id = res.data.form_revision.form_id;
              this.user_id = res.data.user_id;
              this.companyInfo = res.data.companyInfo;
              this.view_type = res.data.view_type;
              this.formInfo = res.data.form_revision;
              this.created_by = res.data.form_revision.created_by;
              this.companyInfoCheck = JSON.parse(res.data.header_content);
              this.formStatus = res.data.status;

              //setting guest account,
              if (! localStorage.getItem('guestUserId')){
                localStorage.setItem('guestUserId', res.data.guest_user_id) ;
              }
              let data = JSON.parse(res.data.bodyStyle);

              // this.changeColor(data[0].theme_no);
              if (res.data.bodyStyle) {
                this.root.style.setProperty("--form-color", data[0].form_color);
                this.root.style.setProperty("--form-header-color", data[0].form_header_color??'#fff');
                this.root.style.setProperty("--form-header-text-color", data[0].form_header_text_color??'#000000');

                this.root.style.setProperty(
                    "--form-border-color",
                    data[0].form_border_color
                );
                this.root.style.setProperty("--font-color", data[0].font_color);
              } else {

                this.root.style.setProperty("--form-color", "#fff");
                this.root.style.setProperty("--form-border-color", "#898989");
                this.root.style.setProperty("--font-color", "#000");
              }

              // if (res.data.status == 2) {
              //   this.status = res.data.status;
              // }

              // this.getInputsComments();
            }
          })
          .catch(res => {
            console.error(res);
          });
    },
    saveForm,
    getQueryParam,
    // deleteElement(index, form) {
    //   FormBuilder.deleteElement(index, form);
    // },
    cloneElementField,
    focusInput,
    enter,
    editComment,
    editElementProperties,
    deleteComment,
    reloadFun,
    getInputsComments,
    invoiceStatus,
    taskAudit,
    setFormColor,getStyles,getAllDocumentStyles,waitForStylesheets,

  },
  created() {
    this.getData();
    // this.$store.state.inputMode.type = !this.$store.state.inputMode.type;
  },

  watch: {
    form_header_color(){
      this.root.style.setProperty("--form-header-color", this.form_header_color);
      this.select_color[0].form_header_color = this.form_header_color;
      // this.select_color[0] = { form_header_color: this.form_header_color };
      // this.select_color.unshift({ form_header_color: this.form_header_color });

    },
    form_header_text_color(){
      this.root.style.setProperty("--form-header-text-color", this.form_header_text_color);
      // this.select_color[0].form_header_text_color = this.form_header_text_color;
      // this.select_color[0] = { form_header_text_color: this.form_header_text_color };
      this.select_color[0].form_header_text_color = this.form_header_text_color;

    },
    form_color() {
      // this.$store.state.formdesigner.formstyling = {
      //   form_color: this.form_color,
      //   form_border_color: this.form_border_color,
      //   font_color: this.font_color,

      // };
      // const form_colortest = this.form_color;
      this.root.style.setProperty("--form-color", this.form_color);
      this.select_color[0].form_color = this.form_color;



      // this.select_color[0].form_color = this.form_color;
    },
    form_border_color() {
      // this.$store.state.formdesigner.formstyling.form_border_color = this.form_border_color;
      this.root.style.setProperty(
          "--form-border-color",
          this.form_border_color
      );
      this.select_color[0].form_border_color = this.form_border_color;
    },
    font_color() {
      // this.$store.state.formdesigner.formstyling.font_color = this.font_color;
      this.root.style.setProperty("--font-color", this.font_color);
      this.select_color[0].font_color = this.font_color;
    },
  },

  computed: {
    guestUserId(){
      return localStorage.getItem('guestUserId')
    },
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
    filePath() {
      return this.$store.state.uploadFilePath.dataUploadFilePath;
      //  this.$store.dispatch("setValueToPass", documents);
    },
    cssProps() {
      // Return an object that will generate css properties key
      // to match with the themingVars
      //
      // Example output: { '--theme-primary-color': this.themingVars.primaryColor }
      var result = {},
          themingVars = this.themingVars;

      for (var v in themingVars) {
        if (themingVars.hasOwnProperty(v)) {
          var newV = "--theme-" + _.kebabCase(v),
              suffix = "";

          // Add px to the value if the default value contain 'px'
          if (_.includes(newV, "size")) suffix = "px";
          else if (_.includes(newV, "margin")) suffix = "px";
          else if (_.includes(newV, "radius")) suffix = "px";

          result[newV] = themingVars[v] + suffix;
        }
      }

      return result;
    }

    // print() {
    //     let w = window.open()
    //       w.document.write(this.$refs.DownloadComp.$el.innerHTML)
    //       w.document.close()
    //       w.setTimeout(function () {
    //         w.print()
    //       }, 1000)
    // }
  },
  mounted() {
    $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    this.$store.state.inputMode.type = false;
    // this.invoiceStatus();
    this.root = document.documentElement;
  }
};
</script>
<style scoped>
@media print {
  .stacked-divs{
    max-width: 100% !important;
    width: 100% !important;
  }
  /* Adjust flex properties */
  .my-3 {
    display: block; /* Ensure containers are treated as block elements */
  }

  .flex-item {
    display: block; /* Ensure items are treated as block elements */
    width: 100%; /* Ensure items take full width if needed */
    page-break-inside: avoid; /* Prevent breaking inside items if necessary */
  }
  .flex-item .float-right{
    margin-left: auto;
  }


  /* Additional print-specific adjustments */
  /* Hide any elements that are not necessary in print */
  .no-print {
    display: none !important;
  }
  body {
    margin: 0;
  }

  .no-print {
    display: none;
  }

  /* Avoid page breaks inside these elements */
  .avoid-break {
    page-break-inside: avoid;
  }

  /* Force page breaks before or after elements as needed */
  .page-break-before {
    page-break-before: always;
  }

  .page-break-after {
    page-break-after: always;
  }

  /* Ensure the content fits within the printable area */
  .print-container {
    overflow: visible;
  }
}
</style>